import { useState } from 'react'
import { CustomModal } from '@components'
import { Button, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from '@heroui/react'
import PropTypes from 'prop-types'

const CommentsModal = ({ 
  comment = null, 
  description = null, 
  handleClose, 
  handleSave = null, 
  isEditable = true, 
  isSaving = false, 
  showCharacterCount = true,
  subTitle = null,
  title 
}) => {
  const [value, setValue] = useState(comment || "")

  const handleUpdate = (value) => {
    if (value.length <= 1000) {
      setValue(value)
    }
  }

  return (
    <CustomModal
      isOpen={true}
      size="2xl"
      handleClose={() => handleClose()}
      scrollBehavior="outside"
      isDismissable={false}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>

            <ModalBody>
              <div className='mt-2'>
                {subTitle && <h1 className="mb-1 text-xl font-semibold">{subTitle}</h1>}
                {description && <p className="text-base text-content2-foreground">{description}</p>}

                {showCharacterCount && (
                  <p className={`flex items-center justify-between mt-4 p-2 px-4 text-sm -mb-1 font-semibold text-right text-white rounded-lg ${value.length === 1000 ? "bg-red-600" : "bg-green-600"}`}>
                    <span>Character count</span>
                    <span>{value.length} / 1000</span>
                  </p>
                )}
              </div>
              
              <Textarea
                classNames={{ input: "min-h-[400px]" }}
                isDisabled={!isEditable}
                size="lg"
                placeholder="Enter your description"
                value={value}
                onValueChange={handleUpdate}
              />
            </ModalBody>
            
            <ModalFooter>
              { handleSave && (
                <div className="flex justify-between w-full">
                  <Button onPress={() => handleClose()} tabIndex={-1}>Cancel</Button>
                  <Button color="secondary" onPress={() => handleSave(value, handleClose)} isLoading={isSaving}>Save</Button>
                </div>
              )}
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </CustomModal>
  )
}

CommentsModal.propTypes = {
  comment: PropTypes.string,
  description: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func,
  isEditable: PropTypes.bool,
  isSaving: PropTypes.bool,
  showCharacterCount: PropTypes.bool,
  subTitle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
}

export default CommentsModal